import type { Appointment, LifecycleStatus, ScheduleBlock } from './types';
import { effectiveAppointmentLifecycle } from '@clinic/shared';

export function effectiveAppointmentLifecycleStatus(
  appointment: Pick<Appointment, 'lifecycleStatus' | 'endAt'>,
  now: string | Date = new Date(),
): LifecycleStatus {
  return effectiveAppointmentLifecycle(appointment.lifecycleStatus, appointment.endAt, now);
}

export function intervalOverlaps(
  firstStart: string | Date,
  firstEnd: string | Date,
  secondStart: string | Date,
  secondEnd: string | Date,
): boolean {
  return new Date(firstStart) < new Date(secondEnd) && new Date(firstEnd) > new Date(secondStart);
}

export function appointmentOccupiesSchedule(appointment: Appointment): boolean {
  return !['cancelled', 'rescheduled'].includes(appointment.lifecycleStatus);
}

export function blockOccupiesSchedule(block: ScheduleBlock): boolean {
  return block.status === 'active';
}

export function hasScheduleConflict(
  appointments: Appointment[],
  blocks: ScheduleBlock[],
  start: string | Date,
  end: string | Date,
  excludeAppointmentId?: string,
  excludeBlockId?: string,
): boolean {
  return (
    appointments.some(
      (appointment) =>
        appointment.id !== excludeAppointmentId &&
        appointmentOccupiesSchedule(appointment) &&
        intervalOverlaps(start, end, appointment.startAt, appointment.endAt),
    ) ||
    blocks.some(
      (block) =>
        block.id !== excludeBlockId &&
        blockOccupiesSchedule(block) &&
        intervalOverlaps(start, end, block.startAt, block.endAt),
    )
  );
}
